function isPreviewMode(query) {
  return query && typeof query.token === "string";
}
export {
  isPreviewMode
};
//# sourceMappingURL=is-preview-mode.js.map
